export default __webpack_public_path__ + "static/media/maxweb_logo.f4de041b.png";